import { date, Platform } from "quasar";
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/remote-config";
import jwt_decode from "jwt-decode";

export const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export const convertArrayToObject = (array, key) => {
  if (!Array.isArray(array)) {
    return array;
  }

  const initialValue = {};

  return array.reduce((obj, item) => {
    return {
      ...obj,
      [item[key]]: item,
    };
  }, initialValue);
};

export const isEqualObject = (object1, object2) => {
  let arrKeys = Object.keys(object1),
    excludeKeys = ["page", "pageSize"];

  if (arrKeys.length !== Object.keys(object2).length) return false;

  if (!arrKeys.length) return true;

  for (let key of excludeKeys) {
    let searchIndex = arrKeys.indexOf(key);
    if (searchIndex >= 0) arrKeys.splice(searchIndex, 1);
  }

  for (let key of arrKeys) {
    if (typeof object1[key] === "object") {
      if (object2[key] && typeof object2[key] === "object") {
        let isSame = isEqualObject(object1[key], object2[key]);
        if (!isSame) return false;
      } else return false;
    } else if (object1[key] !== object2[key]) {
      return false;
    }
  }

  return true;
};

export const debounce = (func, delay) => {
  let debounceTimer;
  return function () {
    const context = this;
    const args = arguments;
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => func.apply(context, args), delay);
  };
};

export const splashscreenShowHide = (show = false) => {
  if (typeof navigator !== "undefined" && navigator.splashscreen) {
    if (show) navigator.splashscreen.show();
    else navigator.splashscreen.hide();
  }
};

export const reloadPage = () => {
  // splashscreenShowHide(true);

  if (window.location.hash) {
    window.location.hash = "#/";
    window.location.reload();
  } else {
    window.location.assign("/");
  }
};

export const getUserAge = (dateString = Date.now()) => {
  var today = new Date();
  var birthDate = new Date(dateString);
  var age = today.getFullYear() - birthDate.getFullYear();
  var m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
};

export const getMyTeamLevelClass = (n = 0) => {
  if (n == 1) return "level-1";
  if (n == 2) return "level-2";
  if (n == 3) return "level-3";
  if (n == 4) return "level-4";
  if (n == 5) return "level-5";
  return "level-1";
};

export const isFunction = (functionToCheck) =>
  functionToCheck && {}.toString.call(functionToCheck) === "[object Function]";

export const groupListingByKey = (data, key) => {
  let result = data.reduce(function (a, c) {
    let keyVal = getProperty(c, key);
    a[keyVal] = a[keyVal] || [];
    a[keyVal].push(c);
    return a;
  }, Object.create(null));
  return result;
};

function getProperty(obj, prop) {
  var parts = prop.split(".");

  if (Array.isArray(parts)) {
    var last = parts.pop(),
      l = parts.length,
      i = 1,
      current = parts[0];

    while ((obj = obj[current]) && i < l) {
      current = parts[i];
      i++;
    }

    if (obj) {
      return obj[last];
    }
  } else {
    throw "parts is not valid array";
  }
}

/**
 *
 Passed to function:                                                    :::
//:::    lat1, lon1 = Latitude and Longitude of point 1 (in decimal degrees)  :::
//:::    lat2, lon2 = Latitude and Longitude of point 2 (in decimal degrees)  :::
//:::    unit = the unit you desire for results                               :::
//:::           where: 'M' is statute miles (default)                         :::
//:::                  'K' is kilometers                                      :::
//:::                  'N' is nautical miles
 */
export const distance = (lat1, lon1, lat2, lon2, unit) => {
  const roundToTwo = (num) => {
    return +(Math.round(num + "e+2") + "e-2");
  };
  if (lat1 == lat2 && lon1 == lon2) {
    return 0;
  } else {
    var radlat1 = (Math.PI * lat1) / 180;
    var radlat2 = (Math.PI * lat2) / 180;
    var theta = lon1 - lon2;
    var radtheta = (Math.PI * theta) / 180;
    var dist =
      Math.sin(radlat1) * Math.sin(radlat2) +
      Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
    if (dist > 1) {
      dist = 1;
    }
    dist = Math.acos(dist);
    dist = (dist * 180) / Math.PI;
    dist = dist * 60 * 1.1515;
    if (unit == "K") {
      dist = dist * 1.609344;
    }
    if (unit == "N") {
      dist = dist * 0.8684;
    }
    return roundToTwo(dist);
  }
};

export const unmask = (maskedValue, mask) => {
  let defaultTokens = ["#", "X", "S", "A", "a", "!"],
    unmaskedValue = "",
    isToken;

  for (let i = 0; i < maskedValue.length; i++) {
    isToken = false;
    for (let j = 0; j < defaultTokens.length; j++) {
      if (mask[i] == defaultTokens[j]) isToken = true;
    }

    if (isToken) unmaskedValue += maskedValue[i];
  }

  return unmaskedValue;
};

export const signOutFirebaseUser = () => {
  firebase
    .auth()
    .signOut()
    .then(
      function () {
        // console.log("User signed out");
      },
      function (error) {
        // console.error("Failed to sign out user: " + error);
      }
    );
};

export const validateJWTToken = (token) => {
  if (token) {
    var decoded = jwt_decode(token),
      { exp } = decoded;

    if (Date.now() >= exp * 1000) return false;

    return true;
  }
  return false;
};

export const sendMessageToParentApp = (message) => {
  window?.parent?.postMessage(message, "*");
};

export const inIframe = () => {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
};

export const buildManifest = (storeDetails) => {
  if (storeDetails?.account_id) {
    let url = "";
    // url = `manifest.${storeDetails?.account_id}.json`;
    if (storeDetails?.manifest) {
      ////~~~~~~~Dynamic manifest generater code~~~~~~~~~~~~~~~~~////
      let manifest = storeDetails.manifest;
      manifest.start_url = window.location.origin;
      let content = encodeURIComponent(JSON.stringify(manifest));
      url = "data:application/manifest+json," + content;
    } else {
      url = "";
    }
    let element = document.createElement("link");
    element.setAttribute("rel", "manifest");
    element.setAttribute("href", url);

    var pwaCompactScript = document.createElement("script");

    pwaCompactScript.setAttribute("src", "https://unpkg.com/pwacompat");
    pwaCompactScript.setAttribute("crossorigin", "anonymous");

    document?.head?.appendChild(element);
    document?.head?.appendChild(pwaCompactScript);
  }
  //////~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~////
};

export const decodeJwtToken = (token) => {
  return jwt_decode(token);
};
